import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {GalleryWrapper} from '@/components/HotelBox/components/HotelBoxSmall/components/GalleryWrapper';

type Props = {
  isHovered?: boolean;
};

export const Wrapper = styled.div<Props>(
  ({isHovered = false, theme}) => css`
    box-sizing: border-box;

    ${isHovered &&
    css`
      box-shadow: inset 0 0 0 2px ${theme.colors.interactionSecondary};
      border-radius: 5px;

      ${GalleryWrapper} {
        clip-path: inset(2px 2px 0px 2px round 2px 0px 0px 2px);
        border-radius: 4px;
      }
    `}
  `
);
